import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';

@Component({
  selector: 'app-updatedues',
  templateUrl: './updatedues.component.html',
  styleUrls: ['./updatedues.component.scss']
})

export class SupplementaryInvoiceUpdateDuesComponent implements OnInit, AfterViewInit {
  invoiceForm: FormGroup;
  @Input() public cellData: any;
  isFormSubmitted = false;
  showSaveBtn = true;
  useEnterKey: any;
  constructor(
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    private ngxLoaderService: NgxUiLoaderService,
    private _fb: FormBuilder,
    private utilities: Utilities,
  ) { }

  ngOnInit() {
    this.invoiceForm = this._fb.group({
      txtTotal: [{ disabled: true, value: 0.00 }],
      txtReceived: [0.00, Validators.compose([Validators.required, Validators.pattern(/^[0-9]{1,12}(\.[0-9]{1,3})?$/)])],
      txtBal: [{ disabled: true, value: 0.00 }],
    });

    this.bindFields();
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.invoiceForm) : null;
  }

  bindFields() {
    this.invoiceForm.patchValue({
      txtTotal: this.cellData.totalamount == null ? 0 : this.cellData.totalamount,
      txtReceived: null,
      txtBal: this.cellData.balanceamount != 0 ? parseFloat(this.cellData.balanceamount) : parseFloat(this.cellData.balanceamount)
    });
    if (parseFloat(this.cellData.amountbalance) == 0) {
      this.invoiceForm.get('txtReceived').disable();
      this.showSaveBtn = false;
    } else
      this.invoiceForm.get('txtReceived').enable();
  }

  calculateBalance() {
    let obj = null;
    obj = {
      id: this.cellData.id,
      amountreceived: this.invoiceForm.get('txtReceived').value,
      amountbalance: this.invoiceForm.get('txtBal').value,
    }
    obj.amountbalance = this.cellData.amountbalance - obj.amountreceived;
    this.invoiceForm.get('txtBal').setValue((obj.amountbalance));

    if (obj.amountreceived > this.cellData.amountbalance) {
      this.appCoreService.showMessage('Balance Amount cannot be greater than the Total Amount or negative', 'Error', 'error');
      this.invoiceForm.patchValue({
        txtReceived: null,
        txtBal: this.cellData.amountbalance
      })
      this.isFormSubmitted = false;
      return null;
    }
    return obj;
  }

  onSaveClick() {
    const obj = this.calculateBalance();
    if (obj && this.invoiceForm.valid && obj.amountreceived != 0) {
      this.cellData.amountreceived = this.cellData.totalamount - obj.amountbalance;
      this.cellData.amountbalance = obj.amountbalance;
      this.activeModal.close(this.cellData);
    }
  }
}